import { Modal } from 'antd';
import React from 'react';
import { withRouter } from 'next/router';
import TemplatePreviewContent from '~/containers/TemplatePreviewContainer';
import withi18next from '~/hocs/withi18next';
import * as gtag from '~/../libs/gtag';

@withRouter
@withi18next()
class ModalPreviewTemplate extends React.Component {
  render() {
    const {
      router,
      visible,
      handleOpenTemplatePreviewModal,
      selectedTemplate,
      setSelectedTemplate,
      catSlug,
      isHomepage,
      isSearchPage,
      currentTemplateTags,
      catNameByLang,
      templates,
    } = this.props;

    return (
      <Modal
        destroyOnClose
        visible={visible}
        closable
        centered
        onCancel={() => {
          router.back();
          handleOpenTemplatePreviewModal(false);
          setTimeout(() => gtag.pageview(window.location.pathname), 1000);
        }}
        footer={null}
        width={'80%'}
        maskStyle={{ backgroundColor: 'rgba(0, 0, 0, 0.8)' }}
        style={{ marginTop: 60 }}
      >
        <TemplatePreviewContent
          isModal
          catNameByLang={catNameByLang}
          isHomepage={isHomepage}
          isSearchPage={isSearchPage}
          catSlug={catSlug}
          setSelectedTemplate={setSelectedTemplate}
          selectedTemplate={selectedTemplate}
          currentTemplateTags={currentTemplateTags}
          templates={templates}
          handleOpenTemplatePreviewModal={handleOpenTemplatePreviewModal}
        />
        <style jsx global>
          {`
            .ant-modal-close {
              outline: none !important;
            }
            .anticon.anticon-close.ant-modal-close-icon {
              vertical-align: 0.5em;
            }
          `}
        </style>
      </Modal>
    );
  }
}

export default ModalPreviewTemplate;
